import type { VoiceJobStatus } from "./api.ts";
import { getStore, setStore } from "./storage.ts";

export const AI_ITEM_TTL_MS = 15 * 60 * 1000;

type VoiceResult = NonNullable<VoiceJobStatus["result"]>;

const readAiItems = (): Record<string, number> => getStore("ai_items", {});

export const markAiItems = (ids: string[]) => {
	const now = Date.now();
	const stored = readAiItems();
	for (const [id, expires] of Object.entries(stored)) {
		if (expires <= now) delete stored[id];
	}
	for (const id of ids) stored[id] = now + AI_ITEM_TTL_MS;
	setStore("ai_items", stored);
};

export const aiItemExpiresIn = (id: string) =>
	Math.max(0, (readAiItems()[id] ?? 0) - Date.now());

export const summarizeVoiceResult = ({ items, lists }: VoiceResult) => {
	const count = items.length + lists.length;
	if (!count) return "";
	const label = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;
	const parts =
		count >= 3
			? [
					items.length ? `added ${label(items.length, "item")}` : "",
					lists.length ? `created ${label(lists.length, "list")}` : "",
				]
			: [
					...lists.map((l) => `created list "${l.title}"`),
					...items.map((i) => `added "${i.text}"`),
				];
	return parts
		.filter(Boolean)
		.join(count >= 3 ? " and " : ", ")
		.replace(/^./, (c) => c.toUpperCase());
};
